import type { FeatureFlagKeys } from '@/utils/types/FeatureFlag';

import featureflagStore from '@/stores/featureflagStore';

export const useFeatureFlag = (flag: FeatureFlagKeys): boolean => {
  return featureflagStore((state) => Boolean(state.featureFlags[flag]));
};
